import {
    Dispatch,
    SetStateAction,
    useState,
} from 'react';

interface Config {
    initialPage?: number;
    itemsPerPage?: number;
    itemsCount: number;
}

const usePagination = (
    {
        initialPage = 1,
        itemsPerPage = 30,
        itemsCount,
    }: Config): {
    itemsPerPage: number;
    page: number;
    onGotoPage: Dispatch<SetStateAction<number>>;
    showingFromItem: number;
    showingToItem: number;
    pageCount: number;
    canPreviousPage: boolean;
    canNextPage: boolean;
    onPrevious: () => void;
    onNext: () => void;
} => {
    const [page, onGotoPage] = useState(initialPage);
    const showingFromItem = itemsPerPage * (page - 1) + 1;
    const showingToItem = Math.min(itemsPerPage * page, itemsCount);
    const pageCount = Math.ceil(itemsCount / itemsPerPage);
    const canPreviousPage = page > 1;
    const canNextPage = page < pageCount;
    const onPrevious = (): void => {
        if (canPreviousPage) {
            onGotoPage((prev) => prev - 1);
        }
    };
    const onNext = (): void => {
        if (canNextPage) {
            onGotoPage((prev) => prev + 1);
        }
    };

    return {
        itemsPerPage,
        page,
        onGotoPage,
        showingFromItem,
        showingToItem,
        pageCount,
        canPreviousPage,
        canNextPage,
        onPrevious,
        onNext,
    };
};

export default usePagination;
